import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function ProtectedRoute({ children, roles }) {
  const { user, loading, mustChangePassword } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Forcer le changement de mot de passe (sauf si deja sur la page)
  if (mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" state={{ forced: true }} replace />;
  }

  if (roles) {
    const userRoles = user.roles && user.roles.length > 0 ? user.roles : [user.role];
    if (!roles.some(r => userRoles.includes(r))) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
}
